import { ProductSwiper } from '../../../common/ui/ProductSwiper';
import { mapRemoteData } from '../../../common/domain/RemoteData.model';
import { fetchAllBis } from '../../catalog/infrastructure/CatalogService';
import { useComercialContext } from '../../../comercial/ComercialContext';

const COMBINABLE_FILTER = {
  characteristics: {
    hasCombinable: true
  }
};

export const CombinabledProductsSwiper = () => {
  const { actingAsCliente } = useComercialContext();
  const actingAsNumCliente = actingAsCliente?.numCliente ?? null;
  const fetchFn = () =>
    fetchAllBis(COMBINABLE_FILTER, { amount: 100, page: 0 }, actingAsNumCliente)
      .then(rd => mapRemoteData(rd, ({ content }) => content));
  return (
    <ProductSwiper title={'OFERTAS COMBINABLES'} fetchFn={fetchFn} />
  );
};
